/**
 * ClientSection — datos del cliente como grid 2 columnas. Cada label fijo,
 * cada valor inline-editable.
 */
import type { ClientData } from "../../../types/plan";
import { InlineEditable } from "../InlineEditable";
import { FieldBlock, PageHeader, SectionPage } from "./section-shared";

interface ClientSectionProps {
  data: ClientData;
  onChange: (patch: Partial<ClientData>) => void;
  readonly?: boolean;
}

const FIELDS: Array<{ key: keyof ClientData; label: string }> = [
  { key: "fullName", label: "Nombre completo" },
  { key: "birthdate", label: "Fecha de nacimiento" },
  { key: "age", label: "Edad" },
  { key: "level", label: "Nivel" },
  { key: "weight", label: "Peso actual" },
  { key: "height", label: "Altura" },
  { key: "goal", label: "Objetivo" },
  { key: "injuries", label: "Lesiones / restricciones" },
  { key: "startDate", label: "Inicio del plan" },
  { key: "endDate", label: "Fin del plan" },
];

export function ClientSection({ data, onChange, readonly }: ClientSectionProps) {
  return (
    <SectionPage readonly={readonly}>
      <PageHeader eyebrow="Datos del cliente" title="Datos del cliente" />
      <div className="al-pg-grid-2">
        {FIELDS.map(({ key, label }) => (
          <FieldBlock key={key} label={label}>
            {(key === "startDate" || key === "endDate") && !readonly ? (
              // Date picker para inicio y fin: el calendario necesita fechas
              // YYYY-MM-DD parseables (el fin define hasta dónde corre el plan).
              <input
                type="date"
                className="al-input al-cli-date"
                value={/^\d{4}-\d{2}-\d{2}/.test(String(data[key] ?? "")) ? String(data[key]).slice(0, 10) : ""}
                onChange={(e) => onChange({ [key]: e.target.value } as Partial<ClientData>)}
              />
            ) : (
              <InlineEditable
                value={String(data[key] ?? "")}
                onChange={(v) => onChange({ [key]: v } as Partial<ClientData>)}
                readonly={readonly}
                placeholder="—"
                fieldPath={String(key)}
              />
            )}
          </FieldBlock>
        ))}
      </div>
    </SectionPage>
  );
}
